import React from "react";
import ProfileBio from "./profile_bio";
import AngelInterest from "./angel_interest";
import AngelInvestmentTrend from "./angel_investment_trend";

function AboutPage(props) {
  const { profile, angel, isAboutShow } = props;

  return isAboutShow() && (
    <section className='row d-flex justify-content-center' id='about' name='about'>
      <div className='col-12 col-sm-10'>
        <h2>ABOUT</h2>
        <ProfileBio bio={profile.bio} />
        <AngelInterest interest={angel.interest} />
        <AngelInvestmentTrend investmentTrend={angel.investment_trend} />
      </div>
    </section>
  );
}

export default AboutPage;
